import {
  GET_QRPAYMENTREPORTS,
  POST_QRPAYMENTREPORT,
} from "resources/actionTypes";

// ── QR Payment Report list ────────────────────────────────────────────────────

const initialQrReportList = {
  loading: false,
  error: null,
  qrPaymentList: "",   // mirrors pattern: empty string until first load
};

export const getQrPaymentReportList = (state = initialQrReportList, action) => {
  switch (action.type) {
    case GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_REQUESTED:
      return { ...state, loading: true, error: null };
    case GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_SUCCESS:
      return { ...state, loading: false, qrPaymentList: action.qrPaymentList };
    case GET_QRPAYMENTREPORTS.GET_QRPAYMENTREPORTS_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};

// ── QR Payment Report export / email request ──────────────────────────────────

const initialQrReportExport = {
  loading: false,
  error: null,
};

export const postQrPaymentReport = (state = initialQrReportExport, action) => {
  switch (action.type) {
    case POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_REQUESTED:
      return { ...state, loading: true, error: null };
    case POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_SUCCESS:
      return { ...state, loading: false };
    case POST_QRPAYMENTREPORT.POST_QRPAYMENTREPORT_FAILED:
      return { ...state, loading: false, error: action.message };
    default:
      return state;
  }
};
